import * as React from 'react'
import * as util from '../util'
import * as _ from 'lodash'
import {actions} from '../flux'
import {Menu, Dropdown, Input, Icon, Avatar} from 'antd'

import '../styles/desktop/Header3.less'

const {Search} = Input

interface IProps {
    tab: string
    style?: any
    search?: string
}

interface IState {
    session: any
    profile: any
    leftMenuOpt: any[]
    rightMenuOpt: any[]
}

export default class Header extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            session: null,
            profile: null,
            leftMenuOpt: [
                {
                    text: '首页',
                    tab: 'INDEX',
                    href: '/',
                    icon: 'home',
                },
                {
                    text: '论文',
                    tab: 'THESIS',
                    href: '/theses',
                    icon: 'file-text',
                },
                {
                    text: '新闻',
                    tab: 'NEWS',
                    href: '/information',
                    icon: 'profile',
                },
                {
                    text: '招聘',
                    tab: 'JOB',
                    href: '/search',
                    icon: 'user-add',
                },
                {
                    text: '职业生涯',
                    tab: 'CAREERS',
                    href: '/careers',
                    icon: 'careers',
                },
                {
                    text: '论文润色',
                    tab: 'POLISH',
                    href: `${location.origin}/verify/pagejumper?hmsr=1&hmpl=11&hmcu=&hmkw=&hmci=`,
                    icon: 'form',
                },
                /*{
                    text: '会议',
                    tab: 'MEETINGS',
                    href: '/meetings',
                    icon: 'flag',
                },*/
            ],
            rightMenuOpt: [
                {
                    text: '消息',
                    href: '/my/messages',
                },
                {
                    text: '收藏夹',
                    href: '/my/stars',
                },
                {
                    text: '投递箱',
                    href: '/my/applications',
                },
                {
                    text: '我的简历',
                    href: '/profile/resume',
                },
                {
                    text: '我的论文',
                    href: '/my/theses',
                },
                {
                    text: '帐号设置',
                    href: '/profile/account',
                },
                {
                    text: '发布职位',
                    href: '/login/hr',
                },
                {
                    text: '退出',
                    href: '/logout?redirect=/login',
                },
            ],
        }
    }

    componentDidMount() {
        actions.login.get(session => this.setState({session}))
        actions.api.profile.get(profile => this.setState({profile}))
    }

    render() {
        let {leftMenuOpt, rightMenuOpt, profile, session} = this.state
        let {tab, search, children} = this.props
        let style = this.props.style || {}
        let isVisitor = session && session.id && session.openid && !session.profileId && !session.hrId

        return [
            <div className='position-stuff'></div>,
            <div className='header3-wrapper'>
                <div className='header3-content'>
                    <div className='left'>
                        <Dropdown overlay={
                            <Menu
                                selectedKeys={[tab]}
                                style={{width: '150px'}}
                            >
                                <Search
                                    style={{width: '130px', margin: '10px 0 0 10px'}}
                                    ref='searcher'
                                    onSearch={() => location.href = `/searchall?tab=${search}`}
                                    onClick={() => location.href = `/searchall?tab=${search}`}
                                />
                                {_.map(leftMenuOpt, i => {
                                    return (
                                        <Menu.Item key={i.tab}>
                                            <a href={(i.href === '/search' && location.protocol === 'https:') ? 'https://jobs.linkresearcher.com/search' : i.href}>
                                                {/* <Icon style={{ marginRight: '14px'}} type={i.icon} /> */}
                                                <img src={`/assets/icons/${i.icon}.svg`} width='16' height='16'
                                                     style={{marginRight: '14px', marginTop: '-4px'}}/>
                                                {i.text}
                                            </a>
                                        </Menu.Item>
                                    )
                                })}
                            </Menu>
                        }>
                            <div style={{lineHeight: 1, width: 160}}>
                                {util.logo({
                                    width: '116px',
                                    height: '42px',
                                    margin: '14px 10px 14px 0'
                                }, typeof style.logo === "undefined" ? "" : style.logo)}
                                <Icon type="caret-down"/>
                            </div>
                        </Dropdown>
                    </div>
                    <div className='mid'>
                        {children}
                    </div>
                    <div className='right'>
                        <Icon type="form"/>
                        <a href="/login/hr">发布职位</a>
                        {profile ?
                            <Dropdown overlay={
                                <Menu style={{width: '130px'}}>
                                    {_.map(rightMenuOpt, i => {
                                        return (
                                            <Menu.Item key={i.href}>
                                                <a href={i.href}>
                                                    {i.text}
                                                </a>
                                            </Menu.Item>
                                        )
                                    })}
                                </Menu>
                            }>
                                <Avatar shape="square" size={26} icon="user" src={(profile && profile.avatar) || null}/>
                            </Dropdown> :
                            <a href={isVisitor ? '/join' : `/login?redirect${encodeURIComponent(location.pathname)}`}>
                                <Avatar shape="square" size={26} icon="user" src={(profile && profile.avatar) || null}/>
                            </a>
                        }
                    </div>
                </div>
            </div>
        ]
    }
}